export const blogData = [
  {
    id: "proces-48h",
    title: "Jak oddajemy gotowy projekt w 96h roboczych? Poznaj nasz proces.",
    excerpt:
      "96 godzin roboczych – tyle potrzebujemy, by Twoja wizja stała się rzeczywistością. Jak to robimy bez straty na jakości? Zaufanie, przygotowanie i pełne skupienie.",
    date: "15 sierpnia 2026",
    image: require("../assets/projects/pexels-rdne-7310202.jpg"),
  },
  {
    id: "unikalne-grafiki-ai",
    title: "Nowość: Unikalne grafiki AI w cenie każdej strony",
    excerpt:
      "Koniec z nudnymi zdjęciami z darmowych banków, które ma każda konkurentka. Od teraz tworzymy dla Ciebie klimat premium za pomocą Sztucznej Inteligencji – bez dodatkowych kosztów.",
    date: "25 lipca 2026",
    image: require("../assets/projects/pexels-magnetme-3917414-5839461.jpg"),
  },
  {
    id: "czysty-kod-react",
    title: "Dlaczego React wygrywa z WordPressem w 2026 roku?",
    excerpt:
      "Wielu klientów pyta nas: 'Dlaczego nie WordPress?'. Odpowiedź jest prosta: szybkość, bezpieczeństwo i kontrola. Przeczytaj, dlaczego rezygnacja z ciężkich wtyczek na rzecz czystego kodu to najlepsza inwestycja w przyszłość Twojej marki.",
    date: "20 czerwca 2026",
    image: require("../assets/projects/pexels-firmbee-com-22729701-6963740.jpg"),
  },
  {
    id: "startujemy-z-aktualnosciami",
    title: "Startujemy z Aktualnościami – Sekcja tworzona na prośbę klientów",
    excerpt:
      "Po miesiącach obserwacji trendu w branży i słuchając feedbacku naszych klientów, postanowiliśmy uruchomić oficjalną sekcję Aktualności. Dowiedz się, dlaczego to dla nas milestone, a dla Ciebie okazja do bycia na bieżąco.",
    date: "30 maja 2026",
    image: require("../assets/projects/pexels-dimkidama-15115560.jpg"),
  },
];
